var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex-grow-1 display-container",class:{ 'full-screen': _vm.isFullScreen }},[_c('div',{staticClass:"display-filter",style:({
      backgroundImage: 'url(' + _vm.thumbnail + ')',
    })},[_c('client-only',{attrs:{"placeholder":"Loading..."}},[_c('youtube',{staticClass:"display-image",attrs:{"player-vars":_vm.playerVars,"video-id":_vm.video.params.videoId,"fit-parent":true},on:{"ended":function($event){return _vm.$emit('onVideoEnded')}}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }